import { withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { Button, Container, Header, Segment } from 'semantic-ui-react';
import Auth from '../../stores/Auth';

@withRouter
@inject(root => ({
	auth: root.auth
}))
@observer
export default class Privacy extends React.Component {
	props: {
		auth?: Auth,
		history?: History
	};

	render() {
		const { history, auth } = this.props;
		const role = auth.user.role;
		return (
			<Segment basic>
				<Container text textAlign="justified">
					<Header as="h1" textAlign="center">
						Script Approval Management (SAM)
					</Header>
					<Header as="h2" textAlign="center">
						Privacy Policy
					</Header>

					<Header as="h3">Scope</Header>
					<p>
						This Privacy Policy describes how personal information is handled by Seekwell Pty
						Limited (ABN 91 624 401 618) and The Seekwell Unit Trust (ABN 59 739 246 428)
						(“Seekwell”) as the operator of the Script Approval Manager (“SAM”) website and
						application.
					</p>

					<Header as="h3">Purpose</Header>
					<p>
						Seekwell recognises the importance of your privacy and understands that securing your
						personal information is important to you. We are committed to protecting the personal
						information that you entrust to us.
					</p>

					<p>
						Seekwell has obligations to comply with the Australian Privacy Act 1988 (Cth) ("Privacy
						Act"). This Privacy Policy sets out how Seekwell seeks to ensure that any personal
						information we hold about you is collected, used, stored, safeguarded and disclosed in
						accordance with the Australian Privacy Principles in the Privacy Act. In this Policy,
						‘personal information’ and ‘sensitive information’ have the same meaning as in the
						Privacy Act.
					</p>

					<Header as="h4">What personal information does Seekwell collect on SAM End Users?</Header>
					<p>
						Seekwell recognises the importance of your privacy and understands that securing your
						personal information is important to you. We are committed to protecting the personal
						information that you entrust to us.
					</p>

					<p>
						SAM End User personal information collected by Seekwell may include (but is not limited
						to):
					</p>

					<ul type="disc">
						<li>First and last name</li>
						<li>Job title</li>
						<li>Professional title where applicable</li>
						<li>Clinic name</li>
						<li>Clinic contact details, including address and telephone number</li>
						<li>Clinic email address</li>
						<li>Mobile phone number</li>
						<li>Prescriber number where applicable</li>
						<li>PRODA (RA) number</li>
						<li>Log on credentials (username, password)</li>
					</ul>

					<Header as="h4">How does Seekwell collect and hold your personal information?</Header>
					<p>
						Seekwell collects and holds your personal information when you are granted a licence to
						use SAM as an authorised SAM End User.
					</p>

					<Header as="h4">
						For what purposes does Seekwell collect, hold, use and disclose SAM End User personal
						information collected in SAM?
					</Header>
					<p>
						Seekwell collects, holds, uses and discloses personal information in SAM for the
						following purposes:
					</p>
					<ul type="disc">
						<li>To verify your identity.</li>
						<li>
							To provide a platform for the purposes of submitting immediate authority requests for
							continuing script approvals from Services Australia. (Please note that Immediate
							authority script approvals for initial prescriptions are not currently supported by
							SAM or the PBS/Services Australia).
						</li>
						<li>To provide you with technical customer support.</li>
						<li>
							For general administrative purposes, including training provision and account
							administration.
						</li>
						<li>
							For other purposes required or authorised by or under law, including purposes for
							which you have provided your express or implied consent.
						</li>
					</ul>

					<p>In addition, Seekwell may use and disclose de-identified information:</p>
					<ul type="disc">
						<li>To conduct research and analysis.</li>
						<li>For auditing and reporting purposes.</li>
					</ul>

					<Header as="h4">Unsolicited Personal Information</Header>
					<p>
						If we receive personal information in error and we do not require it for a business
						purpose, we will securely destroy it, or ensure the information is de-identified if we
						are permitted by law and where is practical to do so.
					</p>

					<Header as="h4">Do you have to provide your personal information to Seekwell?</Header>
					<p>
						For the purposes of providing immediate authority script approvals for continuing script
						approvals from Services Australia, you are required to provide your personal
						information. This is an essential feature of the interaction that SAM requires with the
						Services Australia department within the Australian Government. Seekwell is required by
						law to collect your personal information to fulfil or process authority script approval
						requests.
					</p>

					<Header as="h4">Disclosure of your personal information</Header>

					<p>
						Seekwell may be required to disclose your personal information to duly authorised
						governmental authorities or as required by Australian law.
					</p>
					<p>
						Seekwell may provide your personal information to a third party in connection with the
						sale, assignment, or other transfer of the business of Seekwell to which the information
						relates, in which case Seekwell will require any such buyer to agree to manage your
						personal information in accordance with this Privacy Policy.
					</p>

					<p>
						Seekwell may share your personal information with agents, contractors, partners or
						related bodies corporate of Seekwell (collectively “external parties”) in connection
						with the services that these external parties perform for, or with, Seekwell.
					</p>

					<p>
						Any disclosure of your personal information to an external party will only be to the
						extent necessary to fulfil a business purpose. Seekwell will ensure that any external
						party who receives your personal information complies with the Australian Privacy
						Principles and protects your personal information to at least the same standard as
						Seekwell. These external parties are restricted from using your personal information in
						any way other than to provide services for Seekwell.
					</p>

					<Header as="h4">Sharing personal information outside of Australia</Header>
					<p>
						Seekwell does not routinely share personal information with people or organisations
						outside Australia. Seekwell may share de-identified information with organisations
						outside Australia, from time to time.
					</p>

					<Header as="h4">Security of your Personal Information</Header>
					<p>
						Seekwell and its external parties will store your personal information securely.
						Furthermore, Seekwell and its external parties will take all reasonable steps to keep
						secure any personal information we hold about you from misuse, loss, unauthorised
						access, modification or disclosure. Access to personal information is only provided to
						those with a business need and their access is reviewed on a regular basis and removed
						when it is no longer required.
					</p>

					<p>
						Personal information is kept for a number of years to comply with legal requirements.
						Any personal information that is no longer needed is securely destroyed after specific
						retention periods are met.
					</p>

					<p>
						Areas of the SAM application that collect and store personal information use industry
						standard secure socket layer (SSL) encryption.
					</p>

					<Header as="h4">Access and correction</Header>
					<p>
						You have a right to request access to or correction of the personal information held by
						us. You can exercise your right to access and correct your personal information by
						contacting our Privacy Officer via the contact details provided below. To protect your
						personal information, you are required to verify your identity as part of fulfilling an
						access or correction request.
					</p>

					<Header as="h4">Complaints</Header>
					<p>
						If you feel that we have breached the terms of our Privacy Policy or otherwise not
						complied with the Australian Privacy Principles in the management of your personal
						information, you can lodge a written complaint to our Privacy Officer via the contact
						details provided below. Where our Privacy Officer receives a privacy complaint, we will
						respond to you within ten business days Where you are unsatisfied with the outcome, you
						may escalate your complaint to the{' '}
						<a href="http://www.oaic.gov.au/" target="_blank">
							Office of the Australian Information Commissioner
						</a>
						.
					</p>

					<Header as="h4">Currency of this Privacy Policy</Header>
					<p>We may update this Privacy Policy from time to time. </p>

					<Header as="h4">
						<a href="https://www.seekwell.com.au/contact" target="_blank">
							Contact Us
						</a>
					</Header>
					<p>
						You may contact us via email at{' '}
						<a href="mailto:info@seekwell.com.au">info@seekwell.com.au</a>
					</p>

					<Button
						primary
						floated="right"
						onClick={() => {
							history.push(`/app/${role}?s=1`);
						}}
					>
						Back
					</Button>
					<br />
					<br />
				</Container>
			</Segment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Privacy/index.js